<template>
	<div class="px-5 pt-5">
		<label>
			Tipo de Rol
			<v-select
				solo
				return-object
				placeholder="Tipo de rol"
				item-text="name"
				item-value="id"
				:items="globalRoles"
				v-model="globalRoleSelected"
			></v-select>
		</label>
		<label>
			Nombre del Rol
			<v-text-field
				solo
				hide-details
				class="mb-3"
				label="Nombre del rol"
				v-model="name"
			/>
		</label>
		<label>
			Código del rol
			<v-text-field
				solo
				hide-details
				class="mb-3"
				label="Código del rol"
				v-model="code"
			/>
		</label>
		<v-switch
			label="Administrador"
			v-model="flagAdmin"
		></v-switch>
		<section class="modal-filter-footer">
			<modal-sidebar-button
				:is-loading="$v.$invalid"
				@accept-button-clicked="createNewRole"
				@cancel-button-clicked="closeModal(false)"
			/>
		</section>
	</div>
</template>
<script>
import { required } from 'vuelidate/lib/validators';

function created() {
	this.loadData();
}

async function loadData() {
	const { codeProject } = this.$route.params;
	const url = `types-roles?codeProject=${codeProject}`;
	const { data: response } = await this.$http.get(url);
	this.globalRoles = response.data;
}

async function createNewRole() {
	const { idTemplate } = this.$route.params;
	const url = `distribution-template/${idTemplate}`;
	const headers = {
		Accept: `${process.env.ACCEPT_SERVICE_V2}`,
	};
	const body = {
		roleIds: [
			{
				code: this.globalRoleSelected.code,
				codeRole: String(this.code),
				flagStatus: true,
				isAdmin: this.flagAdmin ? 1 : 0,
				name: this.globalRoleSelected.name,
				nameRole: this.name,
				resources: [],
				typeRoleId: this.globalRoleSelected.id,
			},
		],
	};
	await this.$http.patch(url, body, { headers });
	this.showNotification('Rol creado exitosamente');
	this.closeModal(true);
}

function closeModal(flag) {
	this.$emit('close-modal', { reCharge: flag });
}

function validations() {
	return {
		code: { required },
		flagAdmin: { required },
		globalRoleSelected: { required },
		name: { required },
	};
}

function data() {
	return {
		code: '',
		flagAdmin: false,
		globalRoles: [
			{ id: 0, title: 'Role de ejemplo' },
		],
		globalRoleSelected: null,
		name: '',
	};
}

export default {
	name: 'new-rol-component',
	created,
	data,
	methods: {
		closeModal,
		createNewRole,
		loadData,
	},
	validations,
};
</script>




// WEBPACK FOOTER //
// src/components/roles/new-rol-component.vue